// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1LinkedWorkItemResourceSchema } from './v1/linkedWorkItemResourceSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listLinkedWorkItemsPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listLinkedWorkItemsQueryParamsSchema = z.object({
  search: z.optional(z.coerce.string().describe("Search by title or external code")),
  status: z.optional(z.enum(["open", "completed"]).describe("Filter by status: open (no completed_at) or completed. Omit for all items")),
  project_id: z.optional(z.number().int().describe("Filter by associated project ID")),
  assigned_user_id: z.optional(z.number().int().describe("Filter by assigned user ID")),
  external_id: z.optional(z.coerce.string().describe("Filter by exact external_id")),
  limit: z.optional(z.number().int().describe("Maximum number of items to return (default: 10000)")),
  offset: z.optional(z.number().int().describe("Number of items to skip (default: 0)")),
}).optional();

export const listLinkedWorkItemsHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Linked work items retrieved successfully
 */
export const listLinkedWorkItems200Schema = z.array(z.lazy(() => v1LinkedWorkItemResourceSchema));

/**
 * @description Unauthorized
 */
export const listLinkedWorkItems401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Forbidden - api_linked_work feature not enabled
 */
export const listLinkedWorkItems403Schema = z.lazy(() => v1ForbiddenErrorSchema);

export const listLinkedWorkItemsQueryResponseSchema = z.lazy(() => listLinkedWorkItems200Schema);
